import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LoadingOptions } from '../../../../models/shared/loading-options';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule, ProgressBarComponent],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @Input() options: LoadingOptions = LoadingOptions.default();

  constructor(private spinner: NgxSpinnerService) {}

  ngOnInit(): void {
    if (!this.options.backgroundColor || this.options.backgroundColor === '') {
      this.options.backgroundColor = '#f7f7f7';
    }
    if (!this.options.color || this.options.color === '') {
      this.options.color = '#13856b';
    }
    if (!this.options.spinnerColor || this.options.spinnerColor === '') {
      this.options.spinnerColor = this.options.color;
    }
    this.spinner.show();
  }
}
